'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.inline) {
        theme.display = 'inline-block';
    }

    var height = (0, _pixelToNumber2.default)(theme.fontSize) * theme.lineHeight + (0, _pixelToNumber2.default)(theme.paddingTop) + (0, _pixelToNumber2.default)(theme.paddingBottom);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: theme.display,
            minWidth: theme.minWidth,
            width: theme.width,
            height: height + 'px',
            position: 'relative',
            verticalAlign: 'bottom',
            font: theme.tsNormal + '/' + theme.tlSmall + ' "' + theme.fontFamily + '"',
            zoom: 1,
            '&:after': {
                clear: 'both',
                content: '""',
                display: 'block',
                height: 0
            }
        },
        input: {
            overflow: 'hidden',
            position: 'relative',
            width: '100%',
            height: '100%'
        },
        list: {
            position: 'absolute',
            top: 0,
            transition: 'top 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
        },
        item: {
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            paddingTop: theme.paddingTop,
            paddingRight: theme.paddingRight,
            paddingLeft: theme.paddingLeft,
            paddingBottom: theme.paddingBottom,
            color: theme.color,
            background: theme.background,
            border: '0 none',
            fontFamily: theme.fontFamily,
            whiteSpace: 'nowrap',
            textAlign: 'left',
            margin: 0,
            position: 'relative',
            height: height + 'px',
            width: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',

            '&:hover': {
                cursor: 'pointer',
                color: theme.hoverColor,
                backgroundColor: theme.hoverBackground
            },

            '&:focus': {
                outline: '0 none',
                color: theme.focusColor,
                backgroundColor: theme.focusBackground
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        item: (0, _aphroditeJss.css)(styleList.item),
        list: (0, _aphroditeJss.css)(styleList.list),
        input: (0, _aphroditeJss.css)(styleList.input),
        height: height
    };
};

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        display: 'block',
        fontSize: theme.tsNormal,
        lineHeight: 1.5,
        color: theme.tFilled,
        fontFamily: theme.fontFamily,
        background: 'transparent',
        paddingRight: '0',
        paddingLeft: '0',
        paddingTop: theme.gutter + 'px',
        paddingBottom: theme.gutter + 'px',

        hoverColor: theme.tFilled,
        hoverBackground: 'transparent',

        focusColor: theme.tFilled,
        focusBackground: 'transparent',
        width: 'auto',
        minWidth: theme.gutter * 3 + 'px'
    };
};